// @flow
import * as React from "react";
import {reisy} from "reisy";

import type {Publishable as PublishableT} from "../api/types.js";
import type {Options} from "../api/items.js";
import Deck from "./deck.js";
import Multislider from "./multislider.js";
import Section from "./section.js";
import Slide from "./slide.js";
import Article from "../components/article.js";
import Box from "../components/box.js";

const Settings = reisy.namespace("Settings");

type InProps = {
	content: PublishableT;
	parent?: ?PublishableT;
	style?: ?string;
	options: Options;
};
type Props = {
	content: PublishableT;
	parent?: ?PublishableT;
};

const Tile = (props: Props) => {
	const {content, parent} = props;
	return (
		<Article {...props} article={content} collection={parent} styling="tile" />
	);
};
const Loose = (props: Props) => {
	const {content, parent} = props;
	return (
		<Article {...props} article={content} collection={parent} styling="loose" />
	);
};
const Primary = (props: Props) => {
	const {content, parent} = props;
	return (
		<Article {...props} article={content} collection={parent} styling="primary" />
	);
};
const Secondary = (props: Props) => {
	const {content, parent} = props;
	return (
		<Article {...props} article={content} collection={parent} styling="secondary" />
	);
};
const Tertiary = (props: Props) => {
	const {content, parent} = props;
	return (
		<Article {...props} article={content} collection={parent} styling="tertiary" />
	);
};

function getComponent(style: ?string) {
	if (Settings.YeOldeKosk) {
		return Box;
	}

	switch (style) {
	case "section":
		return Section;
	case "deck":
		return Deck;
	case "multislider":
		return Multislider;
	case "slide":
		return Slide;
	case "box":
		return Box;
	case "loose":
		return Loose;
	case "primary":
		return Primary;
	case "secondary":
		return Secondary;
	case "tertiary":
		return Tertiary;
	default:
		return Tile;
	}
}

export const Publishable = (props: InProps) => {
	const {content, style, options, parent, hierarchy, index} = props;
	const Component = getComponent(style);
	return <Component {...options} content={content} parent={parent} hierarchy={hierarchy} index={index} />;
};

export default Publishable;



// WEBPACK FOOTER //
// ./lib/publishables/index.js